import gql from 'graphql-tag';

export const GET_STUDENTS_GUARDIANS = gql`
  query {
    student_guardians(order_by: { id: desc }) {
      guardian_id
      student_id
    }
  }
`;

export const GET_STUDENTS = gql`
  query getStudents {
    students: v_students {
      user_email
      user_first_name
      user_id
      user_last_name
      hc_name
      hc_id
      user_cognito_sub
      user_pic
      is_trial
      trial_end_date
      product_type
      exercises_summary {
        done
        inprogress
        total
      }
      app_submitted: colleges_aggregate(
        where: {
          _and: [
            { status: { _is_null: false } }
            { status: { _neq: "inprogress" } }
          ]
        }
      ) {
        aggregate {
          count
        }
      }
      colleges(
        where: {
          app_deadline: { _neq: null, _gt: "now()" }
          _or: [
            { status: { _is_null: true } }
            { status: { _eq: "inprogress" } }
          ]
        }
        order_by: { app_deadline: asc }
        limit: 1
      ) {
        college_name
        app_deadline
      }
      colleges_aggregate(where: { category: { _neq: "student" } }) {
        aggregate {
          count
        }
      }
      documents_aggregate(
        where: {
          _or: [
            {
              university_id: { _neq: null }
              status: { _eq: "done" }
              university: { deleted: { _eq: false } }
            }
            {
              personal_statements_documents: {
                personal_statement: { status: { _eq: "done" } }
              }
            }
          ]
        }
      ) {
        aggregate {
          count
        }
      }
      milestones(where: { status: { _eq: "inprogress" } }, limit: 1) {
        name
        order
      }
      milestones_aggregate{
        aggregate {
          count
        }
      }
      group_student {
        group_id
        group {
          id
          name
        }
      }
      subscriptions {
          end_date
      }   
    }
  }
`;

export const INSERT_GUARDIAN = gql`
  mutation insertGuardian(
    $studentId: Int!
    $guardianId: Int!
    $relationship: String!
  ) {
    insert_student_guardians_one(
      object: {
        student_id: $studentId
        guardian_id: $guardianId
        relationship: $relationship
      }
    ) {
      id
    }
  }
`;
